import React, { createContext, useContext } from 'react';

export const CampaignEmailHubContext = createContext({
  campaign: null,
  campaignId: '',
  reloadCampaign: async () => {},
});

export function useCampaignEmailHub() {
  return useContext(CampaignEmailHubContext);
}

export function CampaignEmailHubProvider({ value, children }) {
  return (
    <CampaignEmailHubContext.Provider value={value}>
      {children}
    </CampaignEmailHubContext.Provider>
  );
}
